import React, { useState } from "react";
import { Dropdown, Header, Icon, Popup, Ref } from "semantic-ui-react";
import UploadFilesModal from "shared/modals/UploadFilesModal";
import { CloseableContent, ControlledPopup, Notification, STATUS_TYPES } from "dyl-components";
import { useDispatch } from "react-redux";
import contactActions from "actions/contact";

const SubControls = ({ popupRef, dropdownItems, isEllipsisActionDisabled, hasVoicemail, record_id, isAccount, refresh }) => {
    const [isOpen, setIsOpen] = useState(false);

    const closeModal = () => {
        setIsOpen(false);
    }

    const dispatch = useDispatch();
    const action = !hasVoicemail ? 'set' : 'reset';
    const onResetVoicemail = async () => {
        
        try {
            await dispatch(contactActions.resetVoicemail(record_id, { voicemail: !hasVoicemail }, isAccount ? { account: true } : {}));
            Notification.alert(`Successfully ${action} voicemail`, STATUS_TYPES.SUCCESS);
            if (refresh) {
                refresh();
            }
        } catch (e) {
            console.error("Error resetting voicemail:", e);
            Notification.alert(`Failed to ${action} voicemail`, STATUS_TYPES.ERROR);
        }
    }

    return (
        <div className="SubControls">
            <Icon
                className='Profile__controls--less-margin fas fa-fax'
                disabled
                color="white"
            />
            <Popup
                trigger={(
                    <Icon
                        className='Profile__controls--less-margin fas fa-arrow-up-from-bracket'
                        onClick={() => { setIsOpen(isOpen => !isOpen) }}
                                style={{cursor: 'pointer'}}
                    />
                )}
                open={isOpen}
                content={
                    <CloseableContent onClose={()=>setIsOpen(false)}>
                        <UploadFilesModal closeModal={closeModal}/>
                    </CloseableContent>
                }
                position={`bottom right`}
            />
            <ControlledPopup 
                header={(
                    <Header as="h3" textAlign="center">
                        Are you sure?
                        <Header.Subheader style={{ marginTop: 5 }}>
                            VM Drop will be {action}.
                        </Header.Subheader>
                    </Header>
                )}
                trigger={(
                    <Icon
                        className={`Profile__controls--less-margin fas fa-voicemail${!hasVoicemail ? ' VoicemailIcon--unset' : ''}`}
                        link
                    />
                )}
                onConfirm={onResetVoicemail}
                position='bottom center'
            />
            <Ref innerRef={popupRef}>
                <Dropdown
                    icon={
                        <Icon
                            name="ellipsis vertical"
                            className="Profile__controls"
                            link
                        />
                    }
                    pointing={"top right"}
                    disabled={isEllipsisActionDisabled}
                >
                    <Dropdown.Menu>
                        {dropdownItems}
                    </Dropdown.Menu>
                </Dropdown>
            </Ref>
        </div>
    );
};

export default SubControls;
